export enum Colors {
  Primary = 'primary',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  TextSecondary = 'textSecondary',
  Dark = 'dark',
  Grey600 = 'grey600',
}

export enum ButtonVariants {
  Error = 'error',
  Outlined = 'outlined',
}
